import tw, { styled } from 'twin.macro';

import { Stack } from '../Stack/Stack';
import { StyledTextStyle } from '../Typography/TextStyle/TextStyle.styles';
import { ChoiceProps } from './Choice';

export const StyledChoice = styled(Stack)<Pick<ChoiceProps, 'disabled'>>(({ disabled }) => [
	disabled && tw`opacity-50 cursor-default select-none`,
]);

export const StyledLabel = styled(StyledTextStyle)<Pick<ChoiceProps, 'labelHidden'>>(({ labelHidden }) => [
	tw`pt-0.5`,
	labelHidden && tw`sr-only`,
]);
